import { render, staticRenderFns } from "./GenerateDocument.vue?vue&type=template&id=5d95bce2"
import script from "./GenerateDocument.vue?vue&type=script&lang=js"
export * from "./GenerateDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports